import { Box, Stack } from "@mui/material";
import { useMemo } from "react";

import { useGetProductStatusCount } from "../../api/products";
import { PRODUCT_STATUS, ProductStatusColour } from "../../models/Product";
import { camelToCapitalisedWords } from "../../utils/string";
import Text from "../atoms/Text";

interface StatusData {
  status: PRODUCT_STATUS;
  count: number;
  badgeColor: string;
}

const CountIndicator = ({ statusItem }: { statusItem: StatusData }) => {
  return (
    <Stack
      direction={"row"}
      alignItems={"center"}
      spacing={0.5}
      data-testid={`inventory-homepage_product-status-${statusItem.status}`}
    >
      <Text variant={"body_small"}>
        {camelToCapitalisedWords(statusItem.status)}
      </Text>
      <Box
        textAlign={"center"}
        bgcolor={statusItem.badgeColor}
        borderRadius="16px"
        height={24}
        minWidth={24}
        px={1}
        display={"flex"}
        alignItems={"center"}
      >
        <Text variant="body_small">{statusItem.count}</Text>
      </Box>
    </Stack>
  );
};

const StatusCounter = () => {
  const { data } = useGetProductStatusCount();

  const statusData = useMemo(() => {
    if (!data) return [];

    return Object.entries(data).reduce((acc: StatusData[], [status, count]) => {
      const productStatus = status as PRODUCT_STATUS;

      if (productStatus !== PRODUCT_STATUS.DELETED) {
        acc.push({
          status: productStatus,
          count,
          badgeColor: ProductStatusColour[productStatus],
        });
      }

      return acc;
    }, []);
  }, [data]);

  return (
    <Stack direction={"row"} spacing={3} justifyContent={"center"}>
      {statusData.map(item => (
        <CountIndicator key={item.status} statusItem={item} />
      ))}
    </Stack>
  );
};

export default StatusCounter;
